<template>
    <div class="main-container">
        <div class="filter-container" style="position:relative">
            <el-input class="filter-item" v-model="filters.brand_name" placeholder="品牌名称" clearable></el-input>
            <el-select class="filter-item" v-model="filters.status" placeholder="请选择状态" clearable>
                <el-option label="上架" :value="1"></el-option>
                <el-option label="下架" :value="0"></el-option>
            </el-select>
            <el-button class="filter-btn" type="primary" @click="onSearch()">搜索</el-button>
        </div>
        <el-table :data="tableData" stripe border style="width:100%">
            <el-table-column prop="id" label="品牌ID"></el-table-column>
            <el-table-column prop="name" label="品牌名称"></el-table-column>
            <el-table-column label="状态">
                <template #default="scope">
                    {{ scope.row.status === 1 ? '上架' : '下架' }}
                </template>
            </el-table-column>
            <el-table-column label="排序">
                <template #default="scope">
                    <el-input v-model.trim="scope.row.sort_index" placeholder="请输入排序值" @input="scope.row.sort_index=scope.row.sort_index.replace(/^\.+|[^\d.]/g,'')" @blur="onSave(scope.row)" clearable></el-input>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            @current-change="onPageChange"
            :current-page="filters.page"
            layout="total, prev, pager, next, jumper"
            :page-size="filters.size"
            :total="total">
        </el-pagination>
    </div>
</template>

<script>
import { useRoute } from 'vue-router'
import { defineComponent, getCurrentInstance, toRefs, reactive } from 'vue'
import { joinParams } from '@/utils'
export default defineComponent({
name: 'QualificationList',
setup() {
    const { proxy } = getCurrentInstance()
    const route = useRoute()
    
    const state = reactive({
        filters: {
            channel_no: route.query.channel_no, // 当前操作渠道号
            brand_name: '', // 品牌名称
            status:     '', // 品牌状态
            size:       10, // 每页条数
            page:       1,  // 当前页码
        },
        tableData:  [], // 表单数据
        total:      0,  // 总条数
    })

    // 获取品牌列表
    const getList = () => {
        proxy.$http.get(`/admin/brands/get_brand_sort?${joinParams(state.filters)}`).then(res => {
            if (res.code != 200) return proxy.$message({ type: 'error', message: res.msg })
            state.tableData = res.data.data
            state.total = res.data.total || 0
        })
    }
    // 搜索
    const onSearch = () => {
        state.filters.page = 1
        getList()
    }
    // 保存排序值
    const onSave = (row) => {
        const { channel_no } = state.filters
        const { id, sort_index } = row
        proxy.$http.post('/admin/brands/send_brand_sort', { channel_no, id, sort_index }).then(res => {
            const {code, data, msg} = res
            if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
            proxy.$message({ type: 'success', message: '保存成功' })
        })
    }
    // 翻页
    const onPageChange = (val) => {
        state.filters.page = val
        getList()
    }
    getList()
    return { ...toRefs(state), onSearch, onSave, onPageChange }
}
})
</script>